

// fidelity

export const dateFidelity = [

  { id: 1, name: 'FECHA ACREDITADO' },
  { id: 2, name: 'FECHA PAGO' },

]

export const fidelityStatus = [

  { id: 1, name: 'PENDIENTE' },
  { id: 2, name: 'APROBADO' },
  { id: 3, name: 'RECHAZADO' },
  { id: 4, name: 'BLOQUEADO' },
  { id: 5, name: 'CONSUMIDO' }
]

// deposit warranty
export const statusDepositWarrantys = [

  { id: 1, name: 'PENDIENTE' },
  { id: 2, name: 'APROBADO' },
  { id: 3, name: 'RECHAZADO' },
  { id: 4, name: 'BLOQUEADO' },
  // { id: 5, name: 'CONSUMIDO' }

];

// transaction

export const statusTransaction = [

  { id: 1, name: 'PENDIENTE' },
  { id: 2, name: 'APROBADO' },
  { id: 3, name: 'RECHAZADO' },
  { id: 4, name: 'BLOQUEADO' }

];

// payment

export const dateStatusPayment = [

  { id: 1, name: 'FECHA APROBADO'},
  { id: 2, name: 'FECHA RECHAZADO'}

];

export const typePayment = [

  { id: 1, name: 'BLICKOINS'},
  { id: 2, name: 'TARJETA DE CRÉDITO'},
  { id: 3, name: 'DEPOSITO DE GARANTÍA'},
  { id: 4, name: 'TRANSFERENCIA'}

];

export const statusPayment = [

  { id: 1, name: 'PENDIENTE'},
  { id: 2, name: 'APROBADO'},
  { id: 3, name: 'RECHAZADO'}

]

export const transactionTypesDepositWarratys = [
  {id: 3, name: 'Pago Reserva por Créditos Depósitos'},
  {id: 7, name: 'Depósito Recibido'},
]

